import React, { forwardRef } from 'react';
import { useTextInputAction } from '../TextInputAction';

interface IInputProps extends React.ComponentProps<'input'> {
  /** the placeholder, mandatory to handle info/success/errors texts with css pseudo element `placeholder-shown` */
  placeholder: string;
}

export const Input = forwardRef<HTMLInputElement, IInputProps>(
  ({ ...props }, ref) => {
    const { id, isValid, isInvalid } = useTextInputAction();

    return (
      <input
        className={`tw-peer tw-lf-input tw-w-full tw-rounded-l-full tw-rounded-r-none tw-grid-area-[input] disabled:tw-lf-input-disabled invalid:[&:not(:placeholder-shown)]:tw-lf-input-invalid ${
          isValid ? 'tw-lf-input-valid' : ''
        } ${isInvalid ? 'tw-lf-input-invalid' : ''}`}
        id={id}
        ref={ref}
        {...props}
      />
    );
  },
);
